module.exports = __webpack_public_path__ + "static/media/user.2eb50558.svg";